import { API_BASE_URL, HttpStatusCodes, PaginatedResponse } from "./";
import { Publication } from "./publications.model";

export const GET_PUBLICATIONS_URL = `${API_BASE_URL}/publications`;

export interface PublicationsQuery {
  authors?: string[];
  types?: ("dataset" | "journal" | "conference")[];
  publicationYear?: number;
}

export async function getPublications(
  query: PublicationsQuery
): Promise<PaginatedResponse<Publication[]>> {
  // Prepare query params
  const queryParams = new URLSearchParams();
  if (query.authors) queryParams.append("authors", query.authors.join("||"));
  if (query.types) queryParams.append("types", query.types.join("||"));
  if (query.publicationYear)
    queryParams.append("publicationYear", query.publicationYear.toString());

  // Fetch all records until we add pagination
  queryParams.append("pageSize", "500");

  // Make request
  try {
    const response = await fetch(
      `${GET_PUBLICATIONS_URL}?${queryParams.toString()}`,
      {
        headers: { Accept: "application/json" },
      }
    );

    // Remove HTML from abstracts
    // TODO Maybe there is a better way?
    let body = await response.json();
    let publications = body.data as Publication[];
    publications = publications.map((p) => {
      let description = p.description;
      description = description.replace(/<[^>]*>?/gm, "");
      description = description.replace(/&thinsp;/gm, "");
      description = description.replace(/&nbsp;/gm, " ");
      description = description.replace(/&deg;/gm, "°");
      description = description.replace(/&minus;/gm, "−");
      description = description.replace(/&lsquo;/gm, "‘");
      description = description.replace(/&rsquo;/gm, "’");
      description = description.replace(/&ldquo;/gm, "“");
      description = description.replace(/&rdquo;/gm, "”");
      description = description.replace(/&ndash;/gm, "—");
      description = description.replace(/&#39;/gm, "'");
      description = description.replace(/&times;/gm, "×");
      description = description.replace(/&sim;/gm, "~");
      description = description.replace(/&ea-cute;/gim, "é");
      description = description.replace(/&quot;/gim, "'");
      return { ...p, description };
    });

    return [response.status, { ...body, data: publications }];
  } catch (error) {
    console.error("Error in fetching publications!");
    console.error(error);
    return [HttpStatusCodes.RequestFailed, null];
  }
}
